import React from 'react';
import PropTypes from 'prop-types';

import styles from './Label.scss';

const Label = ({htmlFor, text, className, style, title}) => {
	const classNameInner = (className === "") ? styles.default : className;
	return (
		<label htmlFor={htmlFor} className={classNameInner} style={style} title={title}>{text}</label>
	);
};
Label.defaultProps = {
	htmlFor: '',
	text: '',
	className: ''
};

Label.propTypes = {
	htmlFor: PropTypes.string,
	text: PropTypes.string,
	className: PropTypes.string,
	style: PropTypes.object,
	title: PropTypes.string,
};

export default Label;